import React from "react";
import { Box } from "@mui/material";

interface DefaultProps {
  onSelect: (page: string) => void; // Propriedade para retornar o item selecionado
}

const DefaultPage: React.FC<DefaultProps> = ({ onSelect }) => {

    const handleClick = () => {
        onSelect('Questionário'); // Notifica o módulo anterior sobre o item selecionado
      };

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column", // Empilha os elementos verticalmente
        alignItems: "center",
        justifyContent: "space-between", // Distribui os elementos no espaço disponível
        backgroundColor: "#A46CBD",
        padding: "20px 0",
      }}
    >
      {/* Imagem principal (default.svg) */}
      <Box sx={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
        <img
          src="/images/default/default.svg"
          alt="antes de começar"
          style={{ maxWidth: "80%", height: "auto" }}
        />
      </Box>

      {/* Imagem centralizada (comecar.svg) */}
      <Box sx={{ flex: 0, display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#A46CBD", }}>
        <img
          src="/images/default/comecar.svg"
          alt="começar"
          style={{ maxWidth: "60%", height: "auto" }}
          onClick={() => handleClick()}
        />
      </Box>

      {/* Imagem no rodapé (people.svg) */}
      <Box sx={{ width: "100%", backgroundColor: "#A46CBD", }}>
        <img
          src="/images/default/people.svg"
          alt="rodapé"
          style={{ width: "100%", height: "auto" }}
        />
      </Box>
    </Box>
  );
};

export default DefaultPage;